import type { Channel } from "stoat.js";

export function conversations(channels: Channel[], query = "", filter = "all") {
  const search = query.trim().normalize("NFKC").toLocaleLowerCase();
  return channels
    .filter((channel) => {
      if (!["TextChannel", "DirectMessage", "Group"].includes(channel.type))
        return false;
      if (
        channel.type === "TextChannel" &&
        !channel.havePermission("ViewChannel")
      )
        return false;
      if (channel.type === "DirectMessage" && !channel.active) return false;
      if (filter === "unread" && !channel.unread) return false;
      if (filter === "direct" && channel.type !== "DirectMessage") return false;
      if (filter === "team" && channel.type !== "TextChannel") return false;
      return `${channel.displayName ?? ""} ${channel.server?.name ?? ""}`
        .normalize("NFKC")
        .toLocaleLowerCase()
        .includes(search);
    })
    .sort((a, b) =>
      (b.lastMessageId ?? b.id).localeCompare(a.lastMessageId ?? a.id),
    );
}

export function shortTime(date?: Date) {
  if (!date) return "";
  return date.toDateString() === new Date().toDateString()
    ? date.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString("zh-CN", { month: "numeric", day: "numeric" });
}
